// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

type WizardStepsType = {
  steps: Array<string>;
  current: number;
};

const WizardSteps = ({ steps, current }: WizardStepsType) => (
  <Box
    component="ol"
    aria-label="Steps"
    sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: "6px",
      alignItems: "center",
      listStyle: "none",
      margin: "0px",
      padding: "10px 16px",
      backgroundColor: "#4F5266",
    }}
  >
    {steps.map((step, index) => (
      <Typography
        component="li"
        key={step}
        aria-current={index === current ? "step" : undefined}
        fontSize="12px"
        fontWeight={700}
        sx={{
          padding: index === current ? "4px 10px" : "4px 8px",
          borderRadius: "999px",
          color:
            index === current
              ? "#23253A"
              : index < current
                ? "#B5EBDD"
                : "#E8E9EF",
          backgroundColor: index === current ? "#FFFFFF" : "transparent",
        }}
      >
        {`${index + 1} ${step}`}
      </Typography>
    ))}
  </Box>
);

export default WizardSteps;
